const colors={
    primary:'#1abc9c',
    background:'#34495e'
}
export default colors;
